export const GET_POLICY = 'SafelinksGetPolicy';
export const HANDLE_LINK_CLICK = 'SafelinksHandleLinkClick';
export const LINK_CHICLET_OPEN_FAILURE = 'SafelinksLinkChicletOpenFailure';
export const ATP_LICENSE_CHECK = 'SafelinksATPLicenseCheck';
export const REFRESH_POLICY_PERF = 'SafelinksRefreshPolicyPerf';
